export enum ConfigurableFieldName {
  mediaType = 'MediaType'
}